export default __webpack_public_path__ + "static/media/Benefits1.58ba494c.bin";